import { lazy } from 'react';
import { PhotoCamera } from '@mui/icons-material';
import type { ToolDefinition } from '../registry';

export const constatPhotoTool: ToolDefinition = {
  id: 'constat-photo',
  name: 'Constat Photo',
  icon: PhotoCamera,
  basePath: '/constat-photo',
  routes: [
    { path: '/constat-photo', component: lazy(() => import('./ConstatPhotoPage')) },
  ],
};
